(()=>{
'use strict';

const shopContext=window.GTF1ShopContext||{};
const htmlLang=(shopContext.language||document.documentElement.lang||'de').toLowerCase();
const selectedCountry=String(shopContext.country||'DE').toUpperCase();
const germanMarkets=['DE','AT','CH','LI'];
const isGerman=htmlLang.startsWith('de')&&germanMarkets.includes(selectedCountry);
const isEnglish=!isGerman;
const locale=isGerman?'de-DE':'en-GB';
const timeZone=(()=>{
  try{return Intl.DateTimeFormat().resolvedOptions().timeZone||'Europe/Berlin';}
  catch{return 'Europe/Berlin';}
})();
const sourceTimeZone='Europe/Berlin';

function zoneParts(value,zone=timeZone){
  const date=value instanceof Date?value:new Date(value);
  const p=Object.fromEntries(
    new Intl.DateTimeFormat('en-CA',{
      timeZone:zone,
      year:'numeric',month:'2-digit',day:'2-digit',
      hour:'2-digit',minute:'2-digit',second:'2-digit',
      hourCycle:'h23'
    }).formatToParts(date).map(x=>[x.type,x.value])
  );
  return {year:+p.year,month:+p.month,day:+p.day,hour:+p.hour,minute:+p.minute,second:+p.second};
}

function zonedLocalToEpoch(year,month,day,hour,minute,zone=sourceTimeZone){
  const naive=Date.UTC(+year,+month-1,+day,+hour,+minute,0);
  let guess=naive;
  for(let i=0;i<3;i++){
    const p=zoneParts(guess,zone);
    const represented=Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);
    guess=naive-(represented-guess);
  }
  return guess;
}

function parseClock(value){
  const s=String(value||'').trim();
  let m=s.match(/(\d{1,2}):(\d{2})/);
  if(!m)return null;
  let h=+m[1],mi=+m[2];
  if(/\bpm\b/i.test(s)&&h<12)h+=12;
  if(/\bam\b/i.test(s)&&h===12)h=0;
  return {hour:h,minute:mi};
}

function formatTime(value){
  const date=value instanceof Date?value:new Date(value);
  return new Intl.DateTimeFormat(locale,{
    timeZone,
    hour:'numeric',
    minute:'2-digit'
  }).format(date);
}

function formatDate(value,options={}){
  const date=value instanceof Date?value:new Date(value);
  return new Intl.DateTimeFormat(locale,{timeZone,...options}).format(date);
}

function todayParts(){
  const p=zoneParts(Date.now(),timeZone);
  return {year:p.year,month:p.month,day:p.day};
}

function displayParts(value){
  const p=zoneParts(value,timeZone);
  return {
    year:p.year,
    month:p.month,
    day:p.day,
    hour:p.hour,
    minute:p.minute,
    time:formatTime(value)
  };
}

function sourceLocalToDisplayParts(year,month,day,timeText,sourceZone=sourceTimeZone){
  const clock=parseClock(timeText);
  if(!clock)return {year:+year,month:+month,day:+day,time:''};
  const epoch=zonedLocalToEpoch(year,month,day,clock.hour,clock.minute,sourceZone);
  return {...displayParts(epoch),epoch};
}

function normalizeManualEvents(root){
  if(!root)return;
  root.querySelectorAll('[data-f1-event]').forEach(node=>{
    if(node.dataset.gtLocalized==='1')return;
    const timeNode=node.querySelector('[data-time]');
    const clock=parseClock(timeNode?.textContent||'');
    const year=+node.dataset.year,month=+node.dataset.month,day=+node.dataset.day;
    if(clock&&year&&month&&day){
      const epoch=zonedLocalToEpoch(year,month,day,clock.hour,clock.minute,sourceTimeZone);
      const p=displayParts(epoch);
      node.dataset.year=String(p.year);
      node.dataset.month=String(p.month);
      node.dataset.day=String(p.day);
      node.dataset.timestamp=String(epoch);
      if(timeNode)timeNode.textContent=p.time;
    }
    node.dataset.gtLocalized='1';
  });
}

const monthNames=Array.from({length:12},(_,i)=>
  new Intl.DateTimeFormat(locale,{month:'long',timeZone:'UTC'}).format(new Date(Date.UTC(2026,i,1)))
);
const weekdayShort=Array.from({length:7},(_,i)=>
  new Intl.DateTimeFormat(locale,{weekday:'short',timeZone:'UTC'}).format(new Date(Date.UTC(2026,0,4+i)))
);
const weekdayLong=Array.from({length:7},(_,i)=>
  new Intl.DateTimeFormat(locale,{weekday:'long',timeZone:'UTC'}).format(new Date(Date.UTC(2026,0,4+i)))
);

const exact={
  'Mehr zu F1 HUB PLUS':'More about F1 HUB PLUS',
  'F1 HUB PLUS kostenlos testen':'Try F1 HUB PLUS for free',
  'Diese Saison sind die zukünftigen PLUS-Funktionen noch kostenlos freigeschaltet.':'This season, the future PLUS features are still unlocked for free.',
  'Ab der nächsten Saison sind einzelne Premium-Funktionen hinter F1 HUB PLUS. Der Großteil des Hubs bleibt kostenlos – der kleine PLUS-Beitrag hilft dabei, Server-, Daten- und laufende Kosten der erweiterten Features abzudecken.':'From next season, selected premium features will be part of F1 HUB PLUS. Most of the Hub stays free – the small PLUS fee helps cover server, data and ongoing costs for the advanced features.',
  'Dieses goldene PLUS zeigt dir, welche Funktionen künftig im PLUS-Abonnement enthalten sind.':'This gold PLUS shows which features will be included in the PLUS subscription.',
  'Dein F1 HUB PLUS ist aktiv':'Your F1 HUB PLUS is active',
  'Du hast Zugriff auf alle freigeschalteten PLUS-Funktionen.':'You have access to all unlocked PLUS features.',
  'Du nutzt F1 HUB Free':'You are using F1 HUB Free',
  'Basisfunktionen bleiben kostenlos. PLUS schaltet die erweiterten Tools frei.':'Core features stay free. PLUS unlocks the advanced tools.',
  'PLUS freischalten':'Unlock PLUS',
  'Dieses Feature ist Teil von F1 HUB PLUS':'This feature is part of F1 HUB PLUS',
  'Schalte F1 HUB PLUS frei, um dieses Feature vollständig zu nutzen.':'Unlock F1 HUB PLUS to use this feature in full.',
  'Rennkalender & Sessions':'Race calendar & sessions',
  'Fahrer- & Team-WM':"Drivers' & Constructors' Championship",
  'Ergebnisse':'Results',
  'Live Wetter':'Live weather',
  'WM-Rechner':'Championship calculator',
  'Community Votes':'Community votes',
  'Zum Kalender':'Go to calendar',
  'Zum WM Rechner':'Go to championship calculator',
  'Zum WM-Rechner':'Go to championship calculator',
  'Kalender':'Calendar',
  'Rennwochenenden & Sessions':'Race weekends & sessions',
  'Wetter':'Weather',
  'Rankings & WM':'Standings & championship',
  'Kostenlose Vorschau':'Free preview',
  'Das bekommst du im F1 Hub':'What you get in the F1 Hub',
  '100 % kostenlos':'100% free',
  'F1 Hub kostenlos freischalten':'Unlock the F1 Hub for free',
  'Newsletter abonnieren. E-Mail bestätigen. Einloggen. Fertig.':'Subscribe to the newsletter. Confirm your email. Log in. Done.',
  'E-Mail eintragen':'Enter email',
  'E-Mail bestätigen':'Confirm email',
  'Einloggen & nutzen':'Log in & use',
  'Deine E-Mail-Adresse':'Your email address',
  'E-Mail-Adresse eingeben':'Enter email address',
  'Kostenlos freischalten':'Unlock for free',
  'Kostenlos. Kein Abo nötig. Newsletter jederzeit abbestellbar.':'Free. No paid subscription required. Unsubscribe from the newsletter anytime.',
  'Schon bestätigt oder bereits Newsletter-Abonnent?':'Already confirmed or already subscribed?',
  'Einloggen & F1 Hub öffnen':'Log in & open F1 Hub',
  'Zu den Features!':'See the features!',
  'Alle Features im Überblick':'All features at a glance',
  'Einmal kostenlos freischalten und direkt alles nutzen.':'Unlock it for free once and use everything right away.',
  'Kalender & Session-Zeiten':'Calendar & session times',
  'Alle Rennwochenenden, Termine und Sessions auf einen Blick.':'All race weekends, dates and sessions at a glance.',
  'Wetterlage und Regenwahrscheinlichkeit für das Rennwochenende.':'Weather conditions and rain probability for the race weekend.',
  'Platzierungen und die wichtigsten WM-Übersichten.':'Standings and the most important championship overviews.',
  'Fast geschafft!':'Almost there!',
  'Bitte bestätige jetzt die E-Mail in deinem Postfach. Danach loggst du dich hier mit derselben E-Mail-Adresse ein.':'Please confirm the email in your inbox. Then log in here using the same email address.',
  'Jetzt einloggen':'Log in now',
  'Nächstes Rennwochenende':'Next race weekend',
  'NÄCHSTES RENNWOCHENENDE':'NEXT RACE WEEKEND',
  'Rennwochenende':'Race weekend',
  'Grand Prix / Wochenende':'Grand Prix / weekend',
  'Training':'Practice',
  'Freies Training 1':'Practice 1',
  'Freies Training 2':'Practice 2',
  'Freies Training 3':'Practice 3',
  '1. Training':'Practice 1',
  '2. Training':'Practice 2',
  '3. Training':'Practice 3',
  'Sprint-Qualifying':'Sprint Qualifying',
  'Sprint Quali':'Sprint Qualifying',
  'Qualifying':'Qualifying',
  'Rennen':'Race',
  'Termin':'Session',
  'Session':'Session',
  'Uhrzeit':'Time',
  'Uhrzeit folgt':'Time TBA',
  'Ort':'Location',
  'Ort folgt':'Location TBA',
  'Datum':'Date',
  'Flagge':'Flag',
  'Grand Prix':'Grand Prix',
  'TAGE':'DAYS',
  'STUNDEN':'HOURS',
  'MINUTEN':'MINUTES',
  'Tage':'Days',
  'Stunden':'Hours',
  'Minuten':'Minutes',
  'Tippe auf deinen Renntag, um alle Sessionzeiten zu sehen.':'Tap a race day to see all session times.',
  'Sessionzeiten':'Session times',
  'Schließen':'Close',
  'Termine':'Schedule',
  'Gespeicherter Kalenderstand':'Saved calendar snapshot',
  'Automatischer Abruf derzeit nicht verfügbar':'Automatic refresh currently unavailable',
  'Rennsieger':'Race winners',
  'Fahrer-WM':"Drivers' Championship",
  'Team-WM':"Constructors' Championship",
  'Fahrer':'Driver',
  'Team':'Team',
  'Punkte':'Points',
  'Siege':'Wins',
  'Rang':'Position',
  'LIVE-WETTER':'LIVE WEATHER',
  'Sonnig':'Sunny',
  'Leicht bewölkt':'Partly cloudy',
  'Bewölkt':'Cloudy',
  'Regen':'Rain',
  'Vorhersage folgt':'Forecast coming soon',
  'Wer kann noch Weltmeister werden?':'Who can still become World Champion?',
  'Alle mathematisch möglichen Titelkandidaten, ihr frühester WM-Clinch und die Bedingungen dafür.':'All mathematically possible title contenders, their earliest possible clinch and the conditions required.',
  'WM-Daten werden geladen …':'Championship data is loading …',
  'Frühester Titel':'Earliest title',
  'Titel bis Saisonende':'Title by season end',
  'Vorherige Fahrer':'Previous drivers',
  'Weitere Fahrer':'More drivers',
  'Fahrer mit mathematischer WM-Chance':'Drivers with a mathematical title chance',
  'Noch im WM-Kampf':'Still in the title fight',
  'Noch zu holen':'Points still available',
  'Frühestes Titel-Fenster':'Earliest title window',
  'Rest der Saison':'Rest of the season',
  'Saisonfinale':'Season finale',
  'Titel bereits sicher':'Title already secured',
  'Titel bis Saisonende noch möglich':'Title still possible by season end',
  'Frühestens Weltmeister':'Earliest World Champion',
  'Nur noch über Punktgleichheit':'Only possible via a points tie',
  'Bestmöglicher Endstand':'Best possible final score',
  'Ausgewählter Fahrer':'Selected driver',
  'Titel-Status':'Title status',
  'Frühester möglicher Titel':'Earliest possible title',
  'So viele Punkte dürfen sie maximal noch holen':'Maximum points they may still score',
  'Das ist der schnellstmögliche Weg zum Titel.':'This is the fastest possible path to the title.',
  'Daten derzeit nicht erreichbar':'Data currently unavailable',
  'Aktuell konnte kein WM-Szenario berechnet werden.':'No championship scenario could currently be calculated.',
  'F1 HUB PLUS':'F1 HUB PLUS',
  'WM-Rechner ist Teil von F1 HUB PLUS':'The championship calculator is part of F1 HUB PLUS',
  'Simuliere die verbleibenden Rennen, berechne Titelchancen und finde heraus, wann ein Fahrer frühestens Weltmeister werden kann.':'Simulate the remaining races, calculate title chances and see when a driver can clinch the championship at the earliest.',
  'Bereits PLUS? Einloggen':'Already PLUS? Log in',
  'Monatsabo, Jahresabo oder gültiger Season Pass schalten PLUS automatisch frei.':'A monthly plan, yearly plan or valid Season Pass automatically unlocks PLUS.' ,
  'Dein F1 Hub. Kostenlos freischalten.':'Unlock your F1 Hub for free.',
  'Abonniere einmal kostenlos den GRIPTIME Newsletter, bestätige deine E-Mail und logge dich ein. Danach hast du Zugriff auf den kompletten F1 Hub – ohne Kauf und ohne kostenpflichtiges Abo.':'Subscribe to the GRIPTIME newsletter for free, confirm your email and log in. You will then have access to the complete F1 Hub – no purchase or paid subscription required.',
  '100 % KOSTENLOS · NEWSLETTER':'100% FREE · NEWSLETTER',
  'Newsletter abonnieren & freischalten':'Subscribe & unlock',
  '100 % kostenlos. Kein Kauf nötig. Der Newsletter kann jederzeit wieder abbestellt werden.':'100% free. No purchase required. You can unsubscribe from the newsletter anytime.',
  'Das wartet nach der Freischaltung auf dich':'What awaits you after unlocking',
  'Live Rennwochenende':'Live race weekend',
  'Countdown, Sessions und Deutschland-Zeiten':'Countdown, sessions and your local times',
  'Regenchance passend zu den echten Sessionzeiten':'Rain probability matched to the actual session times',
  'Aktuelle Tabellen und Punkte auf einen Blick':'Current standings and points at a glance',
  'Monat auswählen':'Select month',
  'Jahr auswählen':'Select year',
  'Detaillierte Termin-Tabelle':'Detailed schedule table',
  'Markierten Tag antippen · Wochenansicht: nur kommende Sessions · Zeit: Berlin':'Tap a highlighted day · weekly view: upcoming sessions only · local time',
  'In diesem Monat stehen keine weiteren Sessions an. Wähle einen späteren Monat.':'There are no more sessions this month. Choose a later month.',
  'Sprint Wochenende':'Sprint weekend',
  'Mathematisch ausgeschieden':'Mathematically eliminated',
  'Noch möglich · Countback kann entscheiden':'Still possible · countback may decide',
  'Erst im Saisonfinale · Countback nötig':'Only in the season finale · countback required',
  'Frühestens im Saisonfinale':'Earliest in the season finale',
  'Szenario geöffnet':'Scenario open',
  'Szenario ansehen':'View scenario',
  'WM Platz':'Championship position',
  'Bestmöglicher eigener Weg':'Best possible path',
  'Rivalen im Best-Case-Szenario':'Rivals in the best-case scenario',
  'Keine Rivalen mehr':'No rivals remaining',
  'Keine weitere Einschränkung':'No further restriction',
  'Das braucht er':'What he needs',
  'Das dürfen die Rivalen holen':'What the rivals may score',
  'Wichtigste Gegner bis dahin':'Key rivals until then',
  'Er kann den Titel erst im Saisonfinale holen.':'He can only win the title in the season finale.',
  'Aktuell reicht es vorher nur noch bis zu einer Punktgleichheit.':'Before then, the best possible outcome is only a points tie.',
  'Kein anderer Fahrer kann ihn mit den noch verfügbaren Punkten mehr einholen.':'No other driver can catch him with the points still available.',
  'Das ist die generelle Saison-Prognose – unabhängig davon, ob der Titel schon früher entschieden werden kann.':'This is the overall season projection, regardless of whether the title can be decided earlier.',
  'Je mehr Punkte er selbst liegen lässt, desto weniger dürfen die direkten WM-Rivalen holen.':'The more points he drops, the fewer points his direct championship rivals may score.',
  'Titelchance = Modellschätzung aus WM-Stand, Restpunkten, Saisonleistung, Erfahrung und 18.000 simulierten Saisonenden.':'Title chance = model estimate based on championship standings, remaining points, season performance, experience and 18,000 simulated season finishes.',
  'Titelchance = Modellschätzung aus WM-Stand, Restpunkten, Saisonleistung, Erfahrung und 18.000 simulierten Saisonenden. Keine offizielle F1-Quote.':'Title chance = model estimate based on championship standings, remaining points, season performance, experience and 18,000 simulated season finishes. Not an official F1 probability.',
  'WM-Rechner: „Frühester Titel“ zeigt die Chance auf einen Clinch bereits zum frühestmöglichen Termin. „Titel bis Saisonende“ zeigt die generelle WM-Chance. Modellschätzung, keine offizielle F1- oder Wettquote.':'Championship calculator: “Earliest title” shows the chance of clinching at the earliest mathematically possible point. “Title by season end” shows the overall championship chance. Model estimate, not an official F1 or betting probability.',
  'WM-Rechner Ansicht':'Championship calculator view',
  'Auto-Update':'Auto update',
  'Daten derzeit nicht erreichbar':'Data currently unavailable',
  'WM-Rechner konnte noch keine Daten laden. Stelle sicher, dass diese Section unter deinem F1 Hub liegt oder trage optional den F1-Abrufdienst im Theme-Editor ein.':'The championship calculator could not load data yet. Make sure this section is placed below your F1 Hub or optionally enter the F1 data service in the theme editor.'

};

const phraseRules=[
  [/^Heute:/,'Today:'],
  [/ startet als Nächstes$/,' starts next'],
  [/Singapur/g,'Singapore'],
  [/Mexiko-Stadt/g,'Mexico City'],
  [/Österreich/g,'Austria'],
  [/Ungarn/g,'Hungary'],
  [/Belgien/g,'Belgium'],
  [/Niederlande/g,'Netherlands'],
  [/Kanada/g,'Canada'],
  [/Australien/g,'Australia'],
  [/Großbritannien/g,'Great Britain'],
  [/Katar/g,'Qatar'],
  [/^(\d+)\s+Punkte$/,'$1 points'],
  [/^(\d+)\s+Fahrer$/,'$1 drivers'],
  [/Punkte · maximal /g,'points · maximum '],
  [/Punkte · max\. /g,'points · max. '],
  [/ Punkte möglich/g,' points possible'],
  [/ Punkte zur Verfügung/g,' points available'],
  [/max\. (\d+) Punkte/g,'max. $1 points'],
  [/(\d+) Punkte Vorsprung/g,'$1-point lead'],
  [/geschätzte Titelchance/g,'estimated title chance'],
  [/Chance auf frühen Titel/g,'chance of an early title'],
  [/Geschätzte Titelchance/g,'Estimated title chance'],
  [/Titelchance/g,'title chance'],
  [/Weltmeister/g,'World Champion'],
  [/Saisonende/g,'season end'],
  [/Saisonfinale/g,'season finale'],
  [/Rennen/g,'Race'],
  [/Training/g,'Practice'],
  [/Punkte/g,'points'],
  [/Fahrer/g,'drivers'],
  [/Vorhersage folgt/g,'Forecast coming soon'],
  [/Stand (\d{1,2}:\d{2})/g,'Updated $1'],
  [/Gespeicherter Stand/g,'Saved snapshot'],
  [/gespeicherter Stand/g,'saved snapshot']
];

function translateString(value){
  if(!isEnglish)return value;
  const original=String(value??'');
  const lead=original.match(/^\s*/)?.[0]||'';
  const tail=original.match(/\s*$/)?.[0]||'';
  let core=original.trim();
  if(!core)return original;
  if(exact[core])core=exact[core];
  else phraseRules.forEach(([re,repl])=>{core=core.replace(re,repl);});
  return lead+core+tail;
}

function translateElement(el){
  if(!isEnglish||!el||el.nodeType!==1)return;
  ['placeholder','aria-label','title'].forEach(attr=>{
    if(el.hasAttribute?.(attr)){
      const old=el.getAttribute(attr);
      const next=translateString(old);
      if(next!==old)el.setAttribute(attr,next);
    }
  });
  if(el.matches?.('[data-label]')){
    const old=el.getAttribute('data-label');
    const next=translateString(old);
    if(next!==old)el.setAttribute('data-label',next);
  }
  if(el.classList?.contains('fc-preview-zone')){
    el.textContent=`${isEnglish?'Times shown in your local time zone':'Alle Zeiten in deiner lokalen Zeitzone'} · ${timeZone}`;
  }
}

function translateTree(root=document){
  if(!isEnglish)return;
  const scope=root.nodeType===1?root:document.body;
  if(!scope)return;
  if(scope.nodeType===1)translateElement(scope);
  scope.querySelectorAll?.('*').forEach(translateElement);

  const walker=document.createTreeWalker(scope,NodeFilter.SHOW_TEXT,{
    acceptNode(node){
      const p=node.parentElement;
      if(!p||/^(SCRIPT|STYLE|NOSCRIPT)$/.test(p.tagName))return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    }
  });
  const nodes=[];
  let n;
  while((n=walker.nextNode()))nodes.push(n);
  nodes.forEach(node=>{
    const next=translateString(node.nodeValue);
    if(next!==node.nodeValue)node.nodeValue=next;
  });
}

function installTranslator(){
  if(!isEnglish)return;
  const run=()=>translateTree(document.body);
  if(document.body)run();
  else document.addEventListener('DOMContentLoaded',run,{once:true});

  const observer=new MutationObserver(mutations=>{
    for(const m of mutations){
      if(m.type==='characterData'&&m.target?.parentElement){
        const node=m.target;
        if(!/^(SCRIPT|STYLE|NOSCRIPT)$/.test(node.parentElement.tagName)){
          const next=translateString(node.nodeValue);
          if(next!==node.nodeValue)node.nodeValue=next;
        }
      }
      m.addedNodes.forEach(node=>{
        if(node.nodeType===1)translateTree(node);
        else if(node.nodeType===3&&node.parentElement){
          const next=translateString(node.nodeValue);
          if(next!==node.nodeValue)node.nodeValue=next;
        }
      });
    }
  });

  const start=()=>{
    if(document.body)observer.observe(document.body,{childList:true,subtree:true,characterData:true});
  };
  if(document.body)start();
  else document.addEventListener('DOMContentLoaded',start,{once:true});
}

window.GTF1Locale={
  isEnglish,
  isGerman,
  selectedCountry,
  language:isEnglish?'en':'de',
  locale,
  timeZone,
  sourceTimeZone,
  monthNames,
  weekdayShort,
  weekdayLong,
  zoneParts,
  zonedLocalToEpoch,
  parseClock,
  formatTime,
  formatDate,
  todayParts,
  displayParts,
  sourceLocalToDisplayParts,
  normalizeManualEvents,
  translate:translateString,
  translateTree,
  localTimeLabel:isEnglish?`Times shown in your local time zone · ${timeZone}`:`Alle Zeiten in deiner lokalen Zeitzone · ${timeZone}`
};

installTranslator();
})();